import createConverter from './lib/create_converter';
import Err from 'models/err';

export default createConverter(Err);



// WEBPACK FOOTER //
// ./src/scripts/adapters/immutable_converters/err_converter.js